import Store from '@/store'

export default [
  {
    path: '/tecnicos',
    name: 'tecnicos-index',
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getPaginateTecnicos')
      next()
    },
    meta: {
      twoLines: false,
      titleAttr: item => item['nome'],
      title: 'Técnicos',
      paginateMethod: 'getPaginateTecnicos',
      paginateAttr: 'paginateTecnicos',
      routeToCreate: 'tecnicos-create',
      routeToEdit: 'tecnicos-update',
      emptyList: 'Nenhum técnico foi cadastrado.',
      avatarIcon: 'supervisor_account',
      pageAttr: 'tecnicoPage',
      pageCommit: 'setTecnicoPage',
      filterAttr: 'tecnicoFilter',
      filterCommit: 'setTecnicoFilter',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/paginate')
    }
  },
  {
    path: '/tecnicos/novo',
    name: 'tecnicos-create',
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getCidades')
      await Store.dispatch('getUsuarios')
      await Store.commit('setTecnico', {})
      next()
    },
    meta: {
      title: 'Novo técnico',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/tecnico/id')
    }
  },
  {
    path: '/tecnicos/:id',
    name: 'tecnicos-update',
    props: true,
    beforeEnter: async (to, from, next) => {
      await Store.dispatch('getCidades')
      await Store.dispatch('getUsuarios')
      await Store.dispatch('getTecnico', {
        id: Number(to.params.id)
      })
      next()
    },
    meta: {
      title: 'Atualizar técnico',
      routeToEditTelefone: 'tecnicos-update-telefone',
      routeToAddTelefone: 'tecnicos-create-telefone',
      documentAttrTelefone: 'tecnico',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/tecnico/id')
    }
  }
]
